import React from 'react';
import styled from 'styled-components';
import { useAuth } from '../contexts/AuthContext';

export default function AdminNotifications() {
  const { role, createNotification } = useAuth();
  const allowed = role === 'Majitel' || role === 'Admin';
  const [text, setText] = React.useState('');
  const [search, setSearch] = React.useState('');
  const [results, setResults] = React.useState([]);
  const [selected, setSelected] = React.useState(null);
  const [busy, setBusy] = React.useState(false);
  const [message, setMessage] = React.useState('');

  React.useEffect(() => {
    let alive = true;
    const run = async () => {
      if (!search || search.length < 2) { setResults([]); return; }
      try {
        const r = await fetch('/api/popups?_=' + Date.now(), { cache: 'no-store' });
        if (!r.ok) return;
        const arr = await r.json();
        const q = search.toLowerCase();
        const filtered = (Array.isArray(arr) ? arr : []).filter(p => (p.title||'').toLowerCase().includes(q));
        if (!alive) return;
        setResults(filtered.slice(0, 30));
      } catch {}
    };
    run();
    return () => { alive = false; };
  }, [search]);

  const onSelect = (p) => {
    const tile = p.listThumb || p.listThumbnail || p.tile || p.thumb || '';
    setSelected({ id: String(p.id), title: p.title || '', thumb: tile });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!allowed) { setMessage('Nemáš oprávnění.'); return; }
    if (!text.trim() && !selected) { setMessage('Zadej text oznámení nebo vyber popup.'); return; }
    setBusy(true);
    setMessage('');
    try {
      await createNotification({ text, popupId: selected?.id, popupTitle: selected?.title, popupThumb: selected?.thumb });
      setText('');
      setSelected(null);
      setSearch('');
      setResults([]);
      setMessage('Notifikace odeslána všem přihlášeným.');
    } catch (e) {
      setMessage('Chyba při odesílání: ' + (e?.message || 'unknown'));
    } finally {
      setBusy(false);
    }
  };

  if (!allowed) return <Container><h4>Notifikace</h4><Info>Pouze Admin/Majitel mohou vytvářet notifikace.</Info></Container>;

  return (
    <Container>
      <h4 className="serialy">Notifikace</h4>
      <Form onSubmit={onSubmit}>
        <Label>Text oznámení</Label>
        <Input value={text} onChange={(e) => setText(e.target.value)} placeholder="Např. Nová epizoda je venku!" />

        <Label>Vybrat seriál/film (volitelné)</Label>
        <Input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Hledat podle názvu..." />
        {results.length > 0 && (
          <Results>
            {results.map(p => {
              const tile = p.listThumb || p.listThumbnail || p.tile || p.thumb || '';
              return (
                <ResultItem key={p.id} onClick={() => onSelect(p)}>
                  <Thumb src={tile || '/images/placeholder-thumb.png'} alt="thumb" />
                  <span>{p.title}</span>
                </ResultItem>
              );
            })}
          </Results>
        )}

        {selected && (
          <Preview>
            <Thumb src={selected.thumb || '/images/placeholder-thumb.png'} alt="preview" />
            <div>
              <div style={{fontWeight:700}}>{selected.title}</div>
              <small>ID: {selected.id}</small>
            </div>
            <Clear type="button" onClick={() => setSelected(null)}>Zrušit</Clear>
          </Preview>
        )}

        <Actions>
          <Btn type="submit" disabled={busy}>{busy ? 'Odesílám…' : 'Odeslat notifikaci'}</Btn>
        </Actions>
        {message && <Info>{message}</Info>}
      </Form>
    </Container>
  );
}

const Container = styled.div`
  font-size: 25px;
  padding: 0 42px;
  color: #fff;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-width: 720px;
`;

const Label = styled.label`
  font-size: 12px;
  opacity: 0.85;
`;

const Input = styled.input`
  width: 100%;
  height: 40px;
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid rgba(255,255,255,0.06);
  background: rgba(255,255,255,0.02);
  color: #e6eef8;
  outline: none;
  font-size: 14px;
`;

const Results = styled.div`
  border: 1px solid rgba(255,255,255,0.06);
  border-radius: 8px;
  padding: 6px;
  max-height: 280px;
  overflow: auto;
  display: grid;
  grid-template-columns: 1fr;
  gap: 6px;
`;

const ResultItem = styled.button`
  width: 100%;
  text-align: left;
  appearance: none;
  border: 0;
  background: transparent;
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 6px;
  border-radius: 6px;
  cursor: pointer;
  color: #e6eef8;
  &:hover { background: rgba(255,255,255,0.04); }
`;

const Thumb = styled.img`
  width: 72px;
  height: 40px;
  object-fit: cover;
  border-radius: 6px;
`;

const Preview = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 6px;
`;

const Clear = styled.button`
  margin-left: auto;
  appearance: none;
  border: 1px solid rgba(255,255,255,0.12);
  background: transparent;
  color: #e6eef8;
  border-radius: 6px;
  padding: 6px 10px;
  cursor: pointer;
`;

const Actions = styled.div`
  margin-top: 6px;
  display: flex; gap: 8px;
`;

const Btn = styled.button`
  appearance: none;
  border: 0;
  border-radius: 8px;
  background: linear-gradient(90deg,#1e90ff,#007bff);
  color: #fff;
  font-weight: 700;
  padding: 10px 14px;
  cursor: pointer;
`;

const Info = styled.div`
  color: #cfdff6;
  margin-top: 6px;
`;
